<template>
  <div class="c-eyelet eyelet">
    <h4 :data-animation="isAnimated ? 'fade' : false">
      {{ data.content }}
    </h4>
  </div>
</template>

<script>
export default {
  name: 'AppEyelet',
  props: {
    data: {
      type: Object,
      required: true,
    },
    isAnimated: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.eyelet {
  h4 {
    font-size: 16px;
    margin: 0;

    @include mq($from: dm) {
      font-size: 20px;
    }

    @include mq($from: dxl) {
      font-size: 24px;
    }
  }
}
</style>
